import React from 'react'
import { useSelector } from 'react-redux'
import { SUBCATEGORIES_API, SUBCATEGORY_SECTIONS_API } from '../../../Utilities/APIs'
import PcNSTTsCRUD from '../../Partials/Layouts/CRUDs/CRUDLayouts/NSTTsCRUD/PcNSTTsCRUD'

function SubcategorySections() {

  const {employee} = useSelector(state => state.auth)

  return (
    <PcNSTTsCRUD

        // parentChild props
        parentDBField={'subcategory'}
        
        // common props
        api={SUBCATEGORY_SECTIONS_API}
        screenTopicSingular={'Subcategory Section'}
        screenTopicPlural={'Subcategory Sections'}
        
        // crud header props
        showTotalInHeading
        
        // crud props
        allowCreate={employee.level === 'superAdmin'}
        allowUpdate={employee.level === 'superAdmin'}
        allowDelete={employee.level === 'superAdmin'}
        
        // field props
        //text props
        textDBField='engName'
        textName='English Name'

        textSelectField='type'
        textSelectOptions={['stat', 'NDI', 'NI']}
        textSelectName='Type'
        
        // select props
        selectApi={SUBCATEGORIES_API}
        selectType={'parent-child'}
        selectDBField={'subcategory'}
        selectName={'Subcategory'}
    />
  )
}

export default SubcategorySections